import { camelCase } from 'lodash';
import { splitBaseGroup } from '../../utils/parameters';

export const parametersWithValues = (groups: IGroups, parameters: IParameters, values: IValues) => {
  const output = groups.map((group) => {
    let isEnabled = values[`${camelCase(group.id)}.enabled`];

    const items = parameters
      .filter((parameter) => parameter.groupId === group.id)
      .filter((parameter) => parameter.name !== 'Enabled')
      .map((parameter) => {
        const value = values[parameter.id];

        return {
          ...parameter,
          value,
        };
      });

    return {
      ...group,
      isEnabled,
      items,
    };
  });

  return splitBaseGroup(output);
};
